import { Schema } from 'store/schemas/Schema';

export type Breadcrumb = {
  name: string;
  item: string;
};

interface IBreadcrumbListSchema {
  list?: Breadcrumb[];
}

export class BreadcrumbListSchema extends Schema {
  list;

  constructor({ list }: IBreadcrumbListSchema) {
    super();
    this.list = list ?? [];
  }

  toJSON() {
    return Schema.cleanse({
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://www.on3.com/',
        },
        ...this.list.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 2,
          name: item.name,
          item: item.item,
        })),
      ],
    });
  }
}
